export default [
  ({ resolve, state, props }) => {
    state.set(`selectr.${props.namespace}.focusedOption`, props.index)
  }
]
